import React, { Component } from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Button, Text, Pane, Heading, toaster } from 'evergreen-ui';

class CheckoutForm extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    async submit() {
        let { token } = await this.props.stripe.createToken({ name: "Name" });
        let response = await fetch("/charge", {
            method: "POST",
            headers: { "Content-Type": "text/plain" },
            body: token.id
        });

        if (response.ok) console.log("Purchase Complete!")
    }

    process = () => {
        let resp = this.props.stripe.createPaymentMethod('card', this.props.stripe.cardElement, {
            billing_details: {
                email: this.props.user.email,
            },
        }).then((result) => {
            if (result.error) {
                throw result.error
            }
            this.props.datafetcher.savePaymentInfo(result.paymentMethod.id, (error, result) => {
                if (error) {
                    toaster.notify('Something went wrong.')
                    throw error
                }

                if (typeof window !== "undefined") {
                    if (window.fbq != null) {
                        window.fbq('track', 'AddPaymentInfo');
                    }
                }

                toaster.notify('Thank you.')
                window.location.reload()
            })
        })
        return resp
    }

    render() {
        return (
            <Pane className="checkout">
                <Pane marginTop={10}>
                    <Pane><Text>We need to save your credit card information. You can close this window, but you need to add your credit card before the trial ends, or your camera will be disconnected from Safewatch in 7 days.</Text></Pane>
                </Pane>
                <Pane marginTop={25}></Pane>
                <CardElement elevation={2} />
                <Pane marginTop={15}></Pane>
                <a href="https://stripe.com" target="_blank" rel="noopener noreferrer">
                    <img height={30} width={137} alt="Stripe logo" src={require("../../images/powered_by_stripe@3x.png")}></img>
                </a>
                <Pane marginTop={20}><Heading size={200}>You won't be billed until you add a camera and leave it on for 7 days. </Heading></Pane>
                <Pane marginTop={5}><Heading size={200}>You will be billed $5/month per active camera.</Heading></Pane>
                <Pane marginTop={5}><Heading size={200}>You can remove your cameras at any point,</Heading></Pane>
                <Pane marginTop={5}><Heading size={200}>and you won't be charged anymore thereafter.</Heading></Pane>
                <Button marginTop={15} onClick={this.process}>Save</Button>
            </Pane >
        );
    }
}

export default injectStripe(CheckoutForm);